var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceThinking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_700_17481)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_700_17481)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.6665,
    cy: 12.8003,
    rx: 2.13333,
    ry: 2.13333,
    fill: "#654025"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.1997,
    cy: 13.3337,
    rx: 2.13333,
    ry: 2.66667,
    fill: "#654025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7725 7.01107C17.4703 4.81405 20.4733 4.55137 21.542 6.59384V6.59384C21.6541 6.80804 21.438 7.04556 21.2142 6.95416L20.9067 6.8286C19.7694 6.36415 18.4779 6.47718 17.4386 7.13212L17.1579 7.30898C16.9534 7.43786 16.6993 7.24148 16.7725 7.01107V7.01107Z",
    fill: "#654025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40044 8.49142C9.64308 6.54985 12.6117 7.07336 13.1154 9.32283V9.32283C13.1682 9.55874 12.898 9.73223 12.7055 9.58603L12.441 9.38517C11.4627 8.6422 10.1859 8.41711 9.0125 8.78073L8.69563 8.87893C8.46472 8.95048 8.27013 8.69504 8.40044 8.49142V8.49142Z",
    fill: "#654025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9429 19.8576C13.6411 18.1888 16.4287 18.4327 17.8113 20.371V20.371C18.0304 20.6782 17.7258 21.0854 17.3693 20.962L16.0635 20.5103C15.2853 20.2411 14.4525 20.1682 13.6393 20.2983L12.2755 20.5163C11.903 20.5759 11.6738 20.122 11.9429 19.8576V19.8576Z",
    fill: "#654025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30401 26.8101L6.34384 19.2402C6.34637 18.7589 6.73722 18.3701 7.21848 18.3701C8.1846 18.3701 8.96779 19.1533 8.96779 20.1194V22.0506C8.96779 22.6161 9.4364 23.0691 10.0016 23.05L19.6131 22.7246C20.2161 22.7041 20.716 23.1874 20.716 23.7908C20.716 24.3499 20.2843 24.8142 19.7267 24.8548L16.1732 25.1136C15.654 25.1514 15.2507 25.5813 15.2459 26.1018L15.2102 30.0329C15.1996 31.199 14.1977 32.1087 13.0359 32.0071L10.8681 31.8174C8.27539 31.5905 6.29032 29.4126 6.30401 26.8101Z",
    fill: "url(#paint1_linear_700_17481)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_700_17481",
    x1: 13.5,
    y1: 8,
    x2: 22,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_700_17481",
    x1: 7.91973,
    y1: 18.8938,
    x2: 7.91973,
    y2: 28.8474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F88C0E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_700_17481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceThinking);
export default __webpack_public_path__ + "static/media/face_thinking.d73c7ebbdfc578a21ce31890943a1f72.svg";
export { ForwardRef as ReactComponent };